module.exports = __webpack_public_path__ + "files/747a74fa34ea4e2453ac327bdbb5297a.png";